import { FC } from 'react'
import { useSelector } from 'react-redux'

import { Tooltip } from 'core-components/library/tooltip'
import { isMps } from 'partner360/components/partnerRanks/components/rankIcon/helpers/isMps'
import { isPoly } from 'partner360/components/partnerRanks/components/rankIcon/helpers/isPoly'
import { isStrategicPrintServices } from 'partner360/components/partnerRanks/components/rankIcon/helpers/isStrategicPrintServices'
import { isStrategicPsServices } from 'partner360/components/partnerRanks/components/rankIcon/helpers/isStrategicPsServices'
import { isTopMarket } from 'partner360/components/partnerRanks/components/rankIcon/helpers/isTopMarket'
import { isTopRetail } from 'partner360/components/partnerRanks/components/rankIcon/helpers/isTopRetail'
import { isTopWW } from 'partner360/components/partnerRanks/components/rankIcon/helpers/isTopWW'
import { selectP360PartnerAllFlags } from 'partner360/features/p360PartnerFlags'

import { ReactComponent as MpsIcon } from './assets/MPS.svg'
import { ReactComponent as NormalIcon } from './assets/normal.svg'
import { ReactComponent as PolyIcon } from './assets/poly.svg'
import { ReactComponent as StrategicPrintIcon } from './assets/StrategicPrint.svg'
import { ReactComponent as StrategicPSIcon } from './assets/StrategicPS.svg'
import { ReactComponent as Goblet } from './assets/top.svg'
import { ReactComponent as Market } from './assets/topMarket.svg'
import { TopIcon } from './components/topIcon/TopIcon'
import { OTHER_FLAG } from './configs'
import { canRenderRankIcon } from './helpers/canRenderRankIcon'
import { isBps } from './helpers/isBps'
import { isOph } from './helpers/isOph'
import { isTopDistributor } from './helpers/isTopDistributor'
import { IRankIconProps } from './models/iRankIconProps'

import styles from './RankIcon.module.scss'

export const RankIcon: FC<IRankIconProps> = ({ partnerFlag, rankConfig, withoutTitles }) => {
  const partnerRanks = useSelector(selectP360PartnerAllFlags)
  const rank = rankConfig ?? partnerRanks.find((it) => it.PartnerFlag === partnerFlag)

  if (!rank || !canRenderRankIcon(rank)) {
    return null
  }

  const renderTooltipContent = () => {
    return <>{rank.Title}</>
  }

  if (isTopMarket(rank.Icon)) {
    if (withoutTitles) {
      return <Market />
    }
    return (
      <Tooltip className={styles.rankIcon} tipContent={renderTooltipContent}>
        {isBps(rank?.PartnerFlag) && (
          <TopIcon bottomSign="BPS">
            <div style={{ height: '28px' }}>
              <Market />
            </div>
          </TopIcon>
        )}
        {isOph(rank?.PartnerFlag) && (
          <TopIcon bottomSign="OPH">
            <div style={{ height: '28px' }}>
              <Market />
            </div>
          </TopIcon>
        )}
      </Tooltip>
    )
  }

  if (isTopWW(rank.Icon)) {
    if (withoutTitles) {
      return <Goblet />
    }
    return (
      <Tooltip className={styles.rankIcon} tipContent={renderTooltipContent}>
        {isBps(rank?.PartnerFlag) && (
          <TopIcon bottomSign="BPS">
            <Goblet />
          </TopIcon>
        )}
        {isOph(rank?.PartnerFlag) && (
          <TopIcon bottomSign="OPH">
            <Goblet />
          </TopIcon>
        )}
        {isTopRetail(rank.PartnerFlag) && (
          <TopIcon bottomSign="Retail">
            <Goblet />
          </TopIcon>
        )}
      </Tooltip>
    )
  }

  if (isTopDistributor(rank?.Icon)) {
    if (withoutTitles) {
      return <Goblet />
    }
    return (
      <Tooltip className={styles.rankIcon} tipContent={renderTooltipContent}>
        <TopIcon bottomSign="Distributor">
          <Goblet />
        </TopIcon>
      </Tooltip>
    )
  }

  if (isPoly(rank.PartnerFlag)) {
    return (
      <Tooltip className={styles.rankIcon} tipContent={renderTooltipContent}>
        <PolyIcon width={30} height={30} />
      </Tooltip>
    )
  }

  if (isMps(rank.PartnerFlag)) {
    return (
      <Tooltip className={styles.rankIcon} tipContent={renderTooltipContent}>
        <MpsIcon width={40} height={40} />
      </Tooltip>
    )
  }
  if (isStrategicPrintServices(rank.PartnerFlag)) {
    return (
      <Tooltip className={styles.rankIcon} tipContent={renderTooltipContent}>
        <StrategicPrintIcon width={40} height={40} />
      </Tooltip>
    )
  }

  if (isStrategicPsServices(rank.PartnerFlag)) {
    return (
      <Tooltip className={styles.rankIcon} tipContent={renderTooltipContent}>
        <StrategicPSIcon width={40} height={40} />
      </Tooltip>
    )
  }

  if (rank?.PartnerFlag === OTHER_FLAG) {
    return <NormalIcon width={30} height={30} />
  }

  return null
}
